module.exports = __webpack_public_path__ + "static/media/benugo-logo.e46782ab.svg";